import { useState, useEffect } from 'react';
import useAuthenticatedApi from '../../../Authentication/components/hooks/useAuthenticatedApi';

export interface ActivationsByOrg {
    org_id: string;
    name: string;
    count: number;
    day: string;
}

export default function useActivationsByOrg(days: number = 30) {
    const [data, setData] = useState<ActivationsByOrg[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const api = useAuthenticatedApi();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await api.get(
                    `/photo-engineers/activations-by-org-for-last-n-days-from-now?days=${days}`,
                );
                setData(response.data);
            } catch (error) {
                console.error('Error fetching activations by org:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [api, days]);

    return { data, isLoading };
}
